import { Component } from '@angular/core';

@Component({
    selector: 'rwidget-customer-account-change-email-aside',
    templateUrl: './customer-account-change-email-aside.component.html',
    styleUrls: ['./customer-account-change-email-aside.component.scss']
})
export class CustomerAccountChangeEmailAsideComponent {}
